import useRequest from '@/websdk/utils/request';

export default (function () {
  // console.error('GET==>', isContinue)
  const { isRequestSuccessed, data, exec } = useRequest({
    url: `/api/maintain/moldunqualified`,
    name: 'MOLD_UNQUALIFIED_GET',
    method: 'GET',
  });
  return [isRequestSuccessed, data || [], exec];
});
